<template>
  <v-dialog width="450" style="backdrop-filter: blur(1px)">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn v-bind="activatorProps" variant="text" :icon="true" flat rounded="pill" density="compact" size="small" class="mr-1">
        <v-icon :icon="['fas', 'trash']" />
      </v-btn>
    </template>
    <template v-slot:default="{ isActive }">
      <v-card rounded="xl" class="text-center">
        <template v-slot:title>
          ПОДТВЕРДИТЕ УДАЛЕНИЕ
        </template>
        <template v-slot:actions>
          <v-btn
              rounded="xl"
              color="green"
              text="ЗАКРЫТЬ"
              @click="isActive.value = false"
          />
          <v-spacer />
          <v-btn
              rounded="xl"
              color="red"
              text="УДАЛИТЬ"
              @click="delete_event"
          />
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>

import { EventsList } from "@/store/wp_planner/events.store"
import { Del_Documents } from "@/store/wp_planner/documents/deleted.store"

export default {
  name: "DeleteEvent__WP_Dialog",
  props: ['event'],
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    delete_event: function () {
      this.deleted.push(this.event)
      this.events.splice(this.events.findIndex(e => e.__ID === this.event.__ID), 1)
      this.dialog = false
    }
  },
  computed: {
    events: {
      get() {
        return EventsList().get()
      },
      set(value) {
        EventsList().set(value)
      }
    },
    deleted: {
      get() {
        return Del_Documents().get()
      },
      set(value) {
        Del_Documents().set(value)
      }
    },
  }
}
</script>

<style scoped>

</style>
